export default __webpack_public_path__ + "static/media/CCSIcon.a3f41a87.svg";